import { Box } from '@mui/material'
import { VolumeProjectionMUITable } from './VolumeProjection.MUITable'
import { useVolumeProjectionTableData } from './VolumeProjection.data'
import { VolumeProjectionViewProps } from './VolumeProjection.types'

export const VolumeProjectionView = ({
  planId,
  workcentreId,
}: VolumeProjectionViewProps) => {
  const { data, isLoading } = useVolumeProjectionTableData(planId, workcentreId)
  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <Box>
        <VolumeProjectionMUITable
          data={data?.table_data ?? []}
          isLoading={isLoading}
          skuCodes={data?.sku_codes ?? []}
          cycleTime={data?.cycle_time ?? []}
          plannedVersion={data?.planned_version ?? []}
          replenishmentType={data?.replenishment_type ?? []}
          workcentreCode={data?.workcentre_code ?? []}
          workcentreKey={data?.workcentre_key ?? []}
        />
      </Box>
    </Box>
  )
}
